import { createStyles } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';

import type { BaseField, FieldDescriptor, StaticFieldProps } from '../../types/common';

export type FieldErrorNoteType = BaseField & {
  type: 'FieldErrorNote';
};

const useStyles = createStyles((theme) => ({
  parent: {
    marginTop: -theme.other.spacing._32,
  },
  label: {
    color: theme.colors.orange[4],
  },
}));

/**
 * Used for displaying immediate error note under a Field component. Hence the negative margin
 */
function FieldErrorNoteElement({ field }: StaticFieldProps<FieldErrorNoteType>) {
  const { classes } = useStyles();

  return (
    <div className={classes.parent}>
      <Text variant="title-small" className={classes.label}>
        {field.label}
      </Text>
    </div>
  );
}

const Descriptor: FieldDescriptor<FieldErrorNoteType> = {
  FieldComponent: FieldErrorNoteElement,
  name: 'FieldErrorNote',
};

export default Descriptor;
